import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const sendNotificationApi = baseApi.injectEndpoints({
  reducerPath: "sendNotificationApi",
  endpoints: (builder) => ({
    sendNotification: builder.mutation({
      query: (user) => {
        return {
          url: "send-notification",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSendNotificationMutation } = sendNotificationApi;
